import { ListingPictureProps } from '@/components/listing/interfaces';
import { PICTURE_API_FULL_URL } from '@/constants/global';
import { Dimension } from '@/utils/prismic/slices';

export type CursorPosition = {
  x: number;
  y: number;
};

export const setPicturesPosition = (pictures: ListingPictureProps[]) =>
  pictures.map((picture, index) => {
    picture.position = index;
    return picture;
  });

export const extractPicIdSorted = (pictures: ListingPictureProps[]) =>
  [...pictures]
    .sort((picA, picB) => picA.position - picB.position)
    .map(picture => picture.id);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const arrayMove = (array: any[], from: number, to: number) => {
  const newArray = [...array];
  const startIndex = to < 0 ? newArray.length + to : to;
  const [item] = newArray.splice(from, 1);
  newArray.splice(startIndex, 0, item);
  return newArray;
};

export const getPictureUrl = (
  { dir, name }: Pick<ListingPictureProps, 'dir' | 'name'>,
  { height, width }: Dimension
): string =>
  `${PICTURE_API_FULL_URL}/${Math.ceil(width)}x${Math.ceil(
    height
  )}/${dir}raw_${name}`;

export const generateRandomString = (): string =>
  Math.random().toString(36).substring(2, 15) +
  Math.random().toString(36).substring(2, 15);
